/**
 * User Roles Enum
 * Must match backend UserRole enum values
 */
export const UserRole = {
  SYSTEM_OWNER: 0,
  ADMIN: 1,
  COMPANY_ADMIN: 2,
  COMPANY_EMPLOYEE: 3,
  USER: 4,
};

/**
 * Role display names
 */
export const RoleDisplayNames = {
  [UserRole.SYSTEM_OWNER]: "System Owner",
  [UserRole.ADMIN]: "Administrator",
  [UserRole.COMPANY_ADMIN]: "Company Admin",
  [UserRole.COMPANY_EMPLOYEE]: "Company Employee",
  [UserRole.USER]: "User",
};

/**
 * Role descriptions
 */
export const RoleDescriptions = {
  [UserRole.SYSTEM_OWNER]: "Full system access with no limitations",
  [UserRole.ADMIN]: "Manages multiple customers and organizations",
  [UserRole.COMPANY_ADMIN]: "Administrator of a specific company",
  [UserRole.COMPANY_EMPLOYEE]: "Employee within a company",
  [UserRole.USER]: "Regular end user with basic access",
};

/**
 * Helper functions for role management
 */
export const RoleHelper = {
  /**
   * Gets display name for a role
   */
  getDisplayName: (role) => RoleDisplayNames[role] || "Unknown",

  /**
   * Gets description for a role
   */
  getDescription: (role) => RoleDescriptions[role] || "",

  /**
   * Checks if role has permission (lower value = higher permission)
   */
  hasPermission: (userRole, requiredRole) => userRole <= requiredRole,

  /**
   * Checks if user is system owner
   */
  isSystemOwner: (role) => role === UserRole.SYSTEM_OWNER,

  /**
   * Checks if user is any type of admin
   */
  isAdmin: (role) =>
    role === UserRole.SYSTEM_OWNER ||
    role === UserRole.ADMIN ||
    role === UserRole.COMPANY_ADMIN,

  /**
   * Checks if user belongs to a company
   */
  isCompanyMember: (role) =>
    role === UserRole.COMPANY_ADMIN || role === UserRole.COMPANY_EMPLOYEE,

  /**
   * Gets all available roles
   */
  getAllRoles: () =>
    Object.keys(UserRole).map((key) => ({
      value: UserRole[key],
      label: RoleDisplayNames[UserRole[key]],
      description: RoleDescriptions[UserRole[key]],
    })),
};
